import { redactLogDetails } from './auditLogPresentation';
import { createClient } from "@supabase/supabase-js";

// ── Supabase
export const getSupabaseConfig = () => {
  let url = process.env.REACT_APP_SUPABASE_URL;
  let key = process.env.REACT_APP_SUPABASE_ANON_KEY;

  if (!url || typeof url !== "string" || !url.trim() || !url.startsWith("http") || url.includes("placeholder")) {
    url = "https://coaeeihqoirrpulxstha.supabase.co";
  }
  if (!key || typeof key !== "string" || !key.trim() || key.includes("placeholder")) {
    key = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNvYWVlaWhxb2lycnB1bHhzdGhhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODY0NjU1NTEsImV4cCI6MjEwMjA0MTU1MX0.QL0OG1lKXffX3nHGzqkThF5WU3mP8BeKoHLt2fkFuzE";
  }
  return { url: url.trim(), key: key.trim() };
};

// ── Supabase Init
const { url: supabaseUrl, key: supabaseKey } = getSupabaseConfig();
export const supabase = createClient(supabaseUrl, supabaseKey, {
  global: {
    fetch: (input, options = {}) => {
      const headers = new Headers(options.headers);
      // The server validates these opaque credentials; company IDs in browser
      // state never grant access. Never attach them to third-party requests.
      if (String(input).startsWith(`${supabaseUrl}/rest/v1/`)) {
        headers.set('x-workspace-host', window.location.hostname.toLowerCase().replace(/\.$/, ''));
        try {
          const session = JSON.parse(localStorage.getItem('tw_current_user') || 'null');
          if (session?.role === 'employee' && session.employeeSessionToken) {
            headers.set('x-employee-id', session.employeeId);
            headers.set('x-employee-token', session.employeeSessionToken);
          }
        } catch (_) {}
      }
      return fetch(input, { ...options, headers });
    }
  }
});

export const logAudit = async (session, action, details) => {
  if (!session) return;
  try {
    const enrichedDetails = {
      ...details,
      ...(session.role === "admin" || session.role === "company" ? {
        admin_username: session.login_username || session.username || (session.role === "admin" ? "admin" : undefined)
      } : {})
    };
    const { error } = await supabase.rpc('record_session_event', {
      p_action: action,
      p_details: redactLogDetails(enrichedDetails),
      p_company_id: session.companyId || details?.company_id || null
    });
    if (error) throw error;

  } catch (e) {
    console.error("Audit log failed:", e);
  }
};
